import axios from 'axios';
import apiConfig from '../api.config';

export default function sendTestEmail({ data }) {
  const {
    host,
    URIs: { sendTestEmail },
  } = apiConfig;

  const uri = `${host}${sendTestEmail}`;

  return axios
    .post(uri, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
